import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../../index';
import { StripeTerminalComponent } from './stripe-terminal';

export function initCustomerTerminalComponent() {
  document.body.addEventListener('customer-terminal-loaded', showTerminal);

  function showTerminal() {
    document.getElementsByName('customer-terminal-element').forEach((element) => {
      if (element.getAttribute('initialized') !== 'true') {
        element.setAttribute('initialized', 'true');
        const root = ReactDOM.createRoot(element);
        const { tenant, contextPath, locationId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <StripeTerminalComponent locationId={locationId}></StripeTerminalComponent>
            </TenantContext.Provider>,
          ),
        );

        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      }
    });
  }
}
